<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :left-side-class="'col-xl-8'"
      has-return
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    />

    <div class="row d-flex justify-content-between mb-0">
      <div class="tag-badge">
        <span class="dot text-center py-2 px-1">
          <i
            class="fas fa-clipboard-list-check color-orange orange-icon orange-icon-badge-align"
          ></i>
        </span>
        <span class="tag-badge-title py-1 pl-2"
          >Añadir Fortalezas y Necesidades</span
        >
      </div>
    </div>

    <ValidationObserver ref="form">
      <div class="row py-2">
        <div class="col-12 col-md-4 mt-2">
          <ValidationProvider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
            :custom-messages="{
              required: 'El área es requerida.'
            }"
          >
            <CustomDropDown
              v-model="model.area"
              label="Área:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :options="collections.areas"
              :clearable="false"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              class="mx-auto"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-md-4 mt-2">
          <ValidationProvider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
            :custom-messages="{
              required: 'El grado es requerido.'
            }"
          >
            <CustomDropDown
              v-model="model.grade"
              label="Grado:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :options="collections.grades"
              :clearable="false"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              class="mx-auto"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-md-4 mt-2">
          <CustomDropDown
            v-model="model.academicYear"
            label="Año académico:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :options="collections.years"
            :clearable="false"
            class="mx-auto"
          />
        </div>
        <div class="col-12 mt-3">
          <ValidationProvider v-slot="{ errors }" mode="eager" rules="required">
            <custom-text-area
              v-model="model.description"
              :clearable="false"
              custom-error-msg="La destreza es requerida."
              :error="errors[0]"
              label="Detalle de la destreza:"
              :maxlength="3000"
              show-char-count
              :count-classes="['d-block text-right']"
              :rows="4"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 mt-3 d-flex justify-content-end">
          <action-button
            type="button"
            text="Guardar"
            i="fas fa-save"
            variant="success"
            class="ml-2 px-4 mb-3"
            @click="handlerSave()"
          />
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import ActionButton from "ActionButton";
import CustomTextArea from "CustomTextArea";
import CustomDropDown from "custom-drop-down";
import { add, initFilters } from "@/services/operations/strengthsneeds";
import mixAlert from "@/mixin/alert.mixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "AddSkill",
  mixins: [mixAlert],
  components: {
    PageHeader,
    ActionButton,
    CustomTextArea,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      collections: {
        areas: [],
        grades: [],
        years: []
      },
      page: {
        icon: "fas fa-calculator",
        title: "Manejo de Catálogo de Fortalezas y Necesidades",
        routes: [
          "Inicio",
          "Operaciones",
          "Manejo de Catálogo de Fortalezas y Necesidades"
        ]
      },
      model: {
        area: null,
        grade: null,
        academicYear: null,
        description: null
      }
    };
  },
  async mounted() {
    await this.loadInitData();
  },
  methods: {
    async loadInitData() {
      const { data } = await initFilters();
      this.collections = data;
    },
    async handlerSave() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        this.ShowToast("Alerta", "Información Incompleta", "error");
        return;
      }

      const payload = {
        areaId: this.model.area.id,
        gradeId: this.model.grade.id,
        academicYearId: this.model.academicYear?.id,
        description: this.model.description
      };

      await add(payload);

      this.ShowToast(
        "Proceso exitoso",
        "La Información ha sido guardada exitosamente.",
        "success"
      );

      this.$router.push({ name: "strengthsNeedsManagement" });
    }
  }
};
</script>

<style scoped lang="scss">
.tag-badge {
  display: flex;
  align-items: center;
  padding-right: 1em;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  margin-bottom: 10px;
}

.dot {
  border-radius: 100%;
  display: inline-block;
  /* top: 268px; */
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
}
.orange-icon {
  color: #ff7058;
  font-size: 16px;
  padding-right: 10px;
  line-height: 25px;
  margin-left: 10px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 16px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
  line-height: 1.2;
}
</style>
